import { useCartContext } from 'state/cart';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ServiceMode } from 'state/service-mode';

export const useIsVehicleDescriptionEnabled = (): boolean => {
  const { serviceMode } = useCartContext();
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );

  return (
    serviceMode === ServiceMode.CURBSIDE ||
    (serviceMode === ServiceMode.DRIVE_THRU && isMobileOrderForDriveThruLaneEnabled)
  );
};
